import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { compose, lifecycle } from 'recompose';
import { reduxForm } from 'redux-form'
import { withLoadingComponent } from '../components/loading';
import { withInviteUserError } from '../components/invite/InviteUserError';
import { SubmissionError } from 'redux-form'
import { setLanguage } from '../store/actions/i18n';
import InviteUserForm from '../components/invite/InviteUserForm';
import {checkToken, inviteUser} from '../store/actions/inviteUser';

const mapStateToProps = (state, ownProps) => {
    return {
        ...state.token,
        initialValues: {
            verificationToken: ownProps.match.params.token
        },
        strings: state.strings
    }
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        checkToken: () => {
            dispatch(checkToken(ownProps.match.params.token))
        },
        onSubmit: (data) => {
            let profile = { displayName: data.displayName,
                            language: data.language,
                            verificationToken: data.verificationToken};

            if(data.password1 || data.password2) {
                data.password1 = data.password1 || '';
                data.password2 = data.password2 || '';

                if(data.password1.localeCompare(data.password2) !== 0)
                    throw new SubmissionError({ password2: 'Password does not match'});

                profile.password = data.password1;
            }

            dispatch(setLanguage(data.language));

            dispatch(inviteUser(profile)).then(()=>{
                ownProps.history.push(`/login`)
            });
        }
    }
};

const lifecycleValue = {
    componentWillMount() {
        this.props.checkToken();
    }
};

export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps),
    lifecycle(lifecycleValue),
    withInviteUserError,
    withLoadingComponent,
    reduxForm({form: 'inviteUserForm'})
)(InviteUserForm);




// WEBPACK FOOTER //
// ./src/containers/InviteUserContainer.js